import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { monroevilleConfig } from "./data";

export default function MonroevillePage() {
  return <CityPageTemplate config={monroevilleConfig} />;
}